import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardRouting1 from "./Pages/DashboardRouting1";
import { checkUser } from "../../Config/FirebaseMethod";

const Admin = () => {
  const [userId, setUserId] = useState("");
  const param = useParams();
  let navigate = useNavigate();

  let checkAuth = () => {
    checkUser()
      .then((res) => {
        setUserId(res);
      })
      .catch((err) => {
        navigate("/");
      });
  };

  useEffect(() => {
    checkAuth();
    document.title = "ADMIN | Aneeq Ullah Khan";
  }, []);

  return (
    <>
      <DashboardRouting1 />
    </>
  );
};

export default Admin;
